import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { customError } from '@woulsl/sentry-config';
import Cookies from 'js-cookie';
import QS from 'qs';
import { MINI_PROGRAM_CONFIG_KEY, MINI_PROGRAM_CONFIG_KEY2, MINIP_INFO } from '@/const';
import Toast from '@/plugins/Toast';
import { getApolloKey, guestPurchase, guestPurchaseNotify } from '@/services/landing';
import bridge, { canUseBridge, isWechatInstalled, jumpAppRoute, jumpMiniApp } from '@/utils/bridge';
import { getEnvEnum, getPathName, isIOS, isJoJoBrowser, isJoJoReadBrowser, isWXBrowser, qsParse } from '@/utils/index';
import { sensElementView } from '@/utils/sensors';
import { openToMiniByScheme, openToWechatBySchema } from '@/utils/wechat';
import OpenMiniappTip from '../components/openMiniappTip';
import { newPromptFunc } from './help';
export * from './pay';
export function openPageByMiniprogram(url, withOrigiin) {
  if (withOrigiin === void 0) {
    withOrigiin = false;
  }

  return __awaiter(this, void 0, void 0, function () {
    var startTime, _a, path, _b, searchUrl, authToken, uid, restProps, env, urlParams, openUrl, miniStr, miniInfo, _c, resultCode, data, endTime, timeout;

    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          startTime = new Date().getTime();
          OpenMiniappTip.show();
          _a = (url === null || url === void 0 ? void 0 : url.split('?')) || [], path = _a[0], _b = _a[1], searchUrl = _b === void 0 ? '' : _b;
          authToken = Cookies.get('authToken');
          uid = Cookies.get('uid');
          restProps = qsParse(searchUrl);
          return [4
          /*yield*/
          , getEnvEnum()];

        case 1:
          env = _d.sent();
          urlParams = QS.stringify(__assign(__assign({}, restProps), {
            state: authToken,
            uid: uid,
            pt: env
          }));
          openUrl = "".concat(withOrigiin ? '' : window.location.origin).concat(path, "?").concat(urlParams);
          miniStr = "type=webview&needLogin=0&linkUrl=".concat(encodeURIComponent(openUrl));
          miniInfo = MINIP_INFO;
          return [4
          /*yield*/
          , getApolloKey(MINI_PROGRAM_CONFIG_KEY)];

        case 2:
          _c = _d.sent(), resultCode = _c.resultCode, data = _c.data;

          if (resultCode === 200 && data) {
            miniInfo = JSON.parse(data);
          }

          openToWechatBySchema(miniStr, miniInfo);
          endTime = new Date().getTime();
          timeout = 3000 - (endTime - startTime);
          timeout = timeout > 0 ? timeout : 0;
          if (!timeout) return [3
          /*break*/
          , 4];
          return [4
          /*yield*/
          , new Promise(function (resolve) {
            setTimeout(resolve, timeout);
          })];

        case 3:
          _d.sent();

          _d.label = 4;

        case 4:
          OpenMiniappTip.hide();
          return [2
          /*return*/
          ];
      }
    });
  });
} // 前往老师添加页统一逻辑

export function gotoAddTeacherPage(searchUrl) {
  return __awaiter(this, void 0, void 0, function () {
    var authToken, uid, restProps, env, urlParams, openUrl, miniStr, miniInfo, _a, resultCode, data, isWxInstall, appLink, _b, status_1, message;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          authToken = Cookies.get('authToken');
          uid = Cookies.get('uid');
          restProps = qsParse(searchUrl);
          return [4
          /*yield*/
          , getEnvEnum()];

        case 1:
          env = _c.sent();
          urlParams = QS.stringify(__assign(__assign({}, restProps), {
            state: authToken,
            uid: uid,
            pt: env
          }));
          openUrl = getPathName("/transferPage.html?".concat(urlParams));
          miniStr = "type=webview&needLogin=0&linkUrl=".concat(encodeURIComponent(openUrl));
          miniInfo = MINIP_INFO;
          return [4
          /*yield*/
          , getApolloKey(MINI_PROGRAM_CONFIG_KEY2)];

        case 2:
          _a = _c.sent(), resultCode = _a.resultCode, data = _a.data;

          if (resultCode === 200 && data) {
            miniInfo = JSON.parse(data);
          } // 登录状态为false


          if (!__store.logged) {
            customError({
              name: '前往体验弹窗按钮点击',
              message: '用户信息获取失败',
              captureContext: {
                level: 'error',
                extra: {
                  uc_switch: uc_switch,
                  logged: __store.logged,
                  url: searchUrl,
                  href: window.location.href,
                  state: authToken,
                  uid: uid,
                  miniProgram: miniInfo.miniProgram
                }
              }
            });
          }

          if (!canUseBridge) return [3
          /*break*/
          , 5];
          return [4
          /*yield*/
          , isWechatInstalled()];

        case 3:
          isWxInstall = _c.sent();

          if (!isWxInstall) {
            return [2
            /*return*/
            , Toast.info('未安装微信，请使用微信扫描二维码访问')];
          }

          appLink = "/pages/transform_space/main?".concat(miniStr);
          return [4
          /*yield*/
          , bridge.call('launchMiniProgram', {
            path: appLink,
            userName: miniInfo.userName,
            miniProgramType: Number(miniInfo.miniProgramType)
          })];

        case 4:
          _b = _c.sent(), status_1 = _b.status, message = _b.message;
          sensElementView({
            c_element_name: '投放落地页_前往体验_APP拉起小程序状态',
            topic_name: status_1 === 200 ? '成功' : '失败',
            activity_label: '投放',
            material_type: message || ''
          });

          if (status_1 !== 200) {
            // 拉起失败尝试使用schema方式唤起
            openToWechatBySchema(miniStr, miniInfo);
          }

          return [3
          /*break*/
          , 6];

        case 5:
          openToWechatBySchema(miniStr, miniInfo);
          _c.label = 6;

        case 6:
          return [2
          /*return*/
          , null];
      }
    });
  });
} // 使用wx 打开页面

export function openLinkUrlByWx(_a) {
  var url = _a.url;
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_b) {
      if (isWXBrowser()) {
        window.location.href = url;
      } else if (isJoJoBrowser()) {
        jumpMiniApp({
          linkUrl: url,
          needLogin: 0,
          miniConf: MINI_PROGRAM_CONFIG_KEY2
        });
      } else {
        openToMiniByScheme({
          linkUrl: url,
          needLogin: 0,
          miniConf: MINI_PROGRAM_CONFIG_KEY2
        });
      }

      return [2
      /*return*/
      ];
    });
  });
}
/**
 * 游客下单
 */

export var createGuestOrder = function createGuestOrder(skuInfo) {
  return __awaiter(void 0, void 0, void 0, function () {
    var res, _a, resultCode, data, id_1;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          Toast.info('支付中...');
          return [4
          /*yield*/
          , guestPurchase({
            skuId: skuInfo.skuId,
            skuName: skuInfo === null || skuInfo === void 0 ? void 0 : skuInfo.courseName,
            skuIcon: skuInfo === null || skuInfo === void 0 ? void 0 : skuInfo.skuCourseImage,
            courseKey: skuInfo === null || skuInfo === void 0 ? void 0 : skuInfo.courseKey
          })];

        case 1:
          res = _b.sent();
          _a = res || {}, resultCode = _a.resultCode, data = _a.data;

          if (resultCode === 200) {
            id_1 = data.id;
            bridge.call('openAppleIAPPay', {
              productId: skuInfo === null || skuInfo === void 0 ? void 0 : skuInfo.externalProductCode,
              payPlatformOrderId: id_1,
              courseKey: skuInfo === null || skuInfo === void 0 ? void 0 : skuInfo.courseKey
            }, function (res1) {
              return __awaiter(void 0, void 0, void 0, function () {
                var _a, status, data1, transactionID, originalTransactionID, nowTime, query, iapAuditRightsConfig, configRes, endTime, timeout_1;

                var _b;

                return __generator(this, function (_c) {
                  switch (_c.label) {
                    case 0:
                      _a = res1 || {}, status = _a.status, data1 = _a.data;
                      console.log('收到js桥回调参数', res1);
                      if (!(status === 200)) return [3
                      /*break*/
                      , 4];
                      transactionID = data1.transactionID, originalTransactionID = data1.originalTransactionID;
                      guestPurchaseNotify({
                        id: id_1,
                        outerProductCode: skuInfo === null || skuInfo === void 0 ? void 0 : skuInfo.externalProductCode,
                        outerOrderId: transactionID,
                        outerOriginOrderId: originalTransactionID
                      });
                      Toast.success('支付成功', 999999999);
                      nowTime = new Date().getTime();
                      query = qsParse();
                      iapAuditRightsConfig = {};
                      return [4
                      /*yield*/
                      , getApolloKey('iap.audit.rights')];

                    case 1:
                      configRes = _c.sent();
                      endTime = new Date().getTime();
                      timeout_1 = 1000 - (endTime - nowTime);
                      timeout_1 = timeout_1 > 0 ? timeout_1 : 0;
                      if (!timeout_1) return [3
                      /*break*/
                      , 3];
                      return [4
                      /*yield*/
                      , new Promise(function (resolve) {
                        setTimeout(resolve, timeout_1);
                      })];

                    case 2:
                      _c.sent();

                      _c.label = 3;

                    case 3:
                      Toast.hide();

                      if ((configRes === null || configRes === void 0 ? void 0 : configRes.resultCode) === 200 && (configRes === null || configRes === void 0 ? void 0 : configRes.data)) {
                        iapAuditRightsConfig = JSON.parse(configRes === null || configRes === void 0 ? void 0 : configRes.data);
                      }

                      if (iapAuditRightsConfig && ((_b = Object.keys(iapAuditRightsConfig)) === null || _b === void 0 ? void 0 : _b.includes((query === null || query === void 0 ? void 0 : query.linkId) || ''))) {
                        bridge.call('H5closeWebController', {}, function () {});
                      } else {
                        jumpAppRoute('tinman-router://cn.tinman.jojoread/course/home');
                      }

                      return [3
                      /*break*/
                      , 5];

                    case 4:
                      Toast.fail('支付失败');
                      _c.label = 5;

                    case 5:
                      return [2
                      /*return*/
                      ];
                  }
                });
              });
            });
          } else {
            Toast.fail('支付失败');
          }

          return [2
          /*return*/
          ];
      }
    });
  });
};
export var checkGuestOrder = function checkGuestOrder(skuInfo) {
  return __awaiter(void 0, void 0, void 0, function () {
    var query, res, iapAuditRightsConfig_1, configRes, isRight_1, res1;

    var _a, _b, _c;

    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          Toast.info('查询中...', 999999999);
          query = qsParse();
          console.log('是否购买js桥入参：', {
            productId: skuInfo === null || skuInfo === void 0 ? void 0 : skuInfo.externalProductCode
          });
          return [4
          /*yield*/
          , bridge.call('visitorHasPurchased', {
            productId: skuInfo === null || skuInfo === void 0 ? void 0 : skuInfo.externalProductCode,
            courseKey: query === null || query === void 0 ? void 0 : query.courseKey
          })];

        case 1:
          res = _d.sent();
          console.log('是否购买js桥返回：', res);
          if (!((res === null || res === void 0 ? void 0 : res.status) === 200)) return [3
          /*break*/
          , 4];
          if (!((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.result)) return [3
          /*break*/
          , 4];
          iapAuditRightsConfig_1 = {};
          return [4
          /*yield*/
          , getApolloKey('iap.audit.rights')];

        case 2:
          configRes = _d.sent();

          if ((configRes === null || configRes === void 0 ? void 0 : configRes.resultCode) === 200 && (configRes === null || configRes === void 0 ? void 0 : configRes.data)) {
            iapAuditRightsConfig_1 = JSON.parse(configRes === null || configRes === void 0 ? void 0 : configRes.data);
          }

          isRight_1 = iapAuditRightsConfig_1 && ((_b = Object.keys(iapAuditRightsConfig_1)) === null || _b === void 0 ? void 0 : _b.includes((query === null || query === void 0 ? void 0 : query.linkId) || ''));
          return [4
          /*yield*/
          , bridge.call('visitorHasRestored', {
            productIds: [skuInfo === null || skuInfo === void 0 ? void 0 : skuInfo.externalProductCode],
            purchaseType: isRight_1 ? 2 : 1
          })];

        case 3:
          res1 = _d.sent();
          console.log('是否恢复js桥返回：', res1);
          Toast.hide();

          if ((res1 === null || res1 === void 0 ? void 0 : res1.status) === 200) {
            if ((_c = res1 === null || res1 === void 0 ? void 0 : res1.data) === null || _c === void 0 ? void 0 : _c.result) {
              newPromptFunc({
                title: '提示',
                content: '该商品已购买',
                btnText: '去学习',
                onCenterBtnClick: function onCenterBtnClick() {
                  jumpAppRoute('tinman-router://cn.tinman.jojoread/course/home');
                }
              });
            } else {
              newPromptFunc({
                title: '提示',
                content: '系统检测到有待恢复订单',
                btnText: '恢复订单',
                onCenterBtnClick: function onCenterBtnClick() {
                  return __awaiter(void 0, void 0, void 0, function () {
                    var productIds;
                    return __generator(this, function (_a) {
                      Toast.info('恢复中...', 999999999);
                      productIds = isRight_1 ? iapAuditRightsConfig_1 : [skuInfo === null || skuInfo === void 0 ? void 0 : skuInfo.externalProductCode];
                      bridge.call('visitorGoToRestore', {
                        productIds: productIds
                      }).then(function (res2) {
                        if ((res2 === null || res2 === void 0 ? void 0 : res2.status) === 200) {
                          Toast.success('恢复成功', 1000);
                          setTimeout(function () {
                            if (isRight_1) {
                              bridge.call('H5closeWebController', {}, function () {});
                            } else {
                              jumpAppRoute('tinman-router://cn.tinman.jojoread/course/home');
                            }
                          }, 1000);
                        } else {
                          Toast.fail('恢复失败');
                        }
                      });
                      return [2
                      /*return*/
                      ];
                    });
                  });
                }
              });
            }

            return [2
            /*return*/
            , true];
          }

          _d.label = 4;

        case 4:
          Toast.hide();
          return [2
          /*return*/
          , false];
      }
    });
  });
};
/**
 * @param {Array<{ type: any; proportion: number }>} bos
 * @param {number} userId
 * @returns {Object|null}
 */

var getAbTestByUserId = function getAbTestByUserId(bos, userId) {
  if (!Array.isArray(bos) || bos.length === 0) {
    return null;
  }

  if (userId == null || userId === 0) {
    return null;
  } // 计算总比例


  var modulusSum = 0;

  for (var _i = 0, bos_1 = bos; _i < bos_1.length; _i++) {
    var item = bos_1[_i];
    modulusSum += Number(item.proportion) || 0;
  }

  var modulusNum = modulusSum === 0 ? 1 : modulusSum;
  var counter = 0;
  var remainder = userId % modulusNum;

  for (var _a = 0, bos_2 = bos; _a < bos_2.length; _a++) {
    var item = bos_2[_a];
    var proportion = Number(item.proportion) || 0;

    if (remainder >= counter && remainder < counter + proportion) {
      return item;
    }

    counter += proportion;
  }

  return null;
};
/**
 * 是否命中IAP灰度控制
 */


export var isUserHitIapGrayscale = function isUserHitIapGrayscale(iapRate) {
  var _a;

  if (!iapRate) {
    return false;
  }

  var userId = Cookies.get('uid') || '0';

  if (!isIOS() || !isJoJoReadBrowser()) {
    return false;
  }

  try {
    var uid = Number(userId);
    var clampedIapRate = Math.min(Math.max(iapRate, 0), 1);
    var matchRate = Math.round(clampedIapRate * 10); // 为了避免浮点数精度问题，乘以10后取整

    var remainingRate = 10 - matchRate;
    var testGroup = [{
      type: true,
      proportion: matchRate
    }, {
      type: false,
      proportion: remainingRate
    }];
    return (_a = getAbTestByUserId(testGroup, uid)) === null || _a === void 0 ? void 0 : _a.type;
  } catch (_b) {
    return false;
  }
};